import { cva, type VariantProps } from 'class-variance-authority';

export const buttonSizeClasses = {
  base: 'gap-x-2 px-4 py-2 text-sm',
  small: 'gap-x-1.5 px-3 py-1.5 text-xs',
};

export const buttonVariants = cva(
  'inline-flex items-center justify-center rounded font-semibold capitalize transition-colors disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'bg-white text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-navy-800 dark:text-gray-200 dark:ring-white/5 dark:hover:bg-navy-700 hover:no-underline focus:no-underline dark:hover:no-underline dark:focus:no-underline',
        primary:
          'bg-blue-500 text-white hover:bg-blue-600 hover:no-underline focus:no-underline dark:hover:no-underline dark:focus:no-underline',
        link: 'bg-transparent text-blue-600 hover:text-blue-700 hover:underline dark:text-blue-400 dark:hover:text-blue-300 gap-0 p-0',
      },
      size: {
        base: buttonSizeClasses.base,
        small: buttonSizeClasses.small,
      },
      isIcon: {
        true: 'px-2',
        false: '',
      },
      isDanger: {
        true: '',
        false: '',
      },
      isLoading: {
        true: 'cursor-not-allowed opacity-60',
        false: '',
      },
      useFocusVisible: {
        true: 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400',
        false: 'focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-blue-400',
      },
    },
    compoundVariants: [
      {
        variant: 'default',
        isDanger: true,
        class: 'text-red-600 dark:text-red-400 dark:hover:text-red-300',
      },
      {
        variant: 'primary',
        isDanger: true,
        class: 'bg-red-600 hover:bg-red-700',
      },
      {
        variant: 'link',
        isDanger: true,
        class: 'text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300',
      },
      {
        isIcon: true,
        size: 'small',
        class: 'px-1.5',
      },
      {
        variant: 'link',
        size: 'base',
        class: 'gap-0 p-0',
      },
      {
        variant: 'link',
        size: 'small',
        class: 'gap-0 p-0',
      },
      {
        variant: 'link',
        useFocusVisible: false,
        class: 'focus:outline-none focus:underline focus:outline-transparent',
      },
      {
        variant: 'link',
        useFocusVisible: true,
        class:
          'focus-visible:outline-none focus-visible:outline-transparent focus-visible:underline',
      },
    ],
    defaultVariants: {
      variant: 'default',
      size: 'base',
      isDanger: false,
      isLoading: false,
      useFocusVisible: true,
    },
  },
);

export type KaButtonVariants = VariantProps<typeof buttonVariants>;
